import { getAppType } from '@vmos2/core';
import get from 'lodash/get';

export const SwitchAppType = ({ ...rest }) => {
  const app = window.location.pathname.includes('/o/') ? 'opat' : getAppType();
  const result = get(rest, app, () => null)();

  if (result === undefined) {
    return null;
  }

  return result;
};
